export default function HomeHero() {
  return (
    <>
      <div className="hero">
        <section className="overlay">
          <div className="max-width">
            <h1 className="heading text-center lg:max-w-4xl">
              Find <span>your new home</span> today
            </h1>
            <p className="text-white mt-5 text-center">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit,
              deleniti!
            </p>
          </div>
        </section>
      </div>
    </>
  )
}
